/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMerchantOverviewGet } from '../fn/merchant/api-merchant-overview-get';
import { ApiMerchantOverviewGet$Params } from '../fn/merchant/api-merchant-overview-get';
import { apiMerchantSyncPost } from '../fn/merchant/api-merchant-sync-post';
import { ApiMerchantSyncPost$Params } from '../fn/merchant/api-merchant-sync-post';
import { MerchantOverviewList } from '../models/merchant-overview-list';


/**
 * Merchant service
 */
@Injectable({ providedIn: 'root' })
export class MerchantService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMerchantOverviewGet()` */
  static readonly ApiMerchantOverviewGetPath = '/api/merchant/overview';

  /**
   * Get merchant overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMerchantOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMerchantOverviewGet$Response(params?: ApiMerchantOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantOverviewList>> {
    return apiMerchantOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get merchant overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMerchantOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMerchantOverviewGet(params?: ApiMerchantOverviewGet$Params, context?: HttpContext): Observable<MerchantOverviewList> {
    return this.apiMerchantOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<MerchantOverviewList>): MerchantOverviewList => r.body)
    );
  }

  /** Path part for operation `apiMerchantSyncPost()` */
  static readonly ApiMerchantSyncPostPath = '/api/merchant/sync';

  /**
   * Upsert a/some merchant/s.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMerchantSyncPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMerchantSyncPost$Response(params: ApiMerchantSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiMerchantSyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert a/some merchant/s.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMerchantSyncPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMerchantSyncPost(params: ApiMerchantSyncPost$Params, context?: HttpContext): Observable<void> {
    return this.apiMerchantSyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
